import { render, staticRenderFns } from "./PendingListContainer.vue?vue&type=template&id=10ee1494&"
import script from "./PendingListContainer.vue?vue&type=script&lang=js&"
export * from "./PendingListContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports